<template>
  <button type="button" class="rounded-xs h-6 w-6 flex items-center justify-center" @click="share">
    <svg-icon-share class="w-full h-full" />
  </button>
</template>

<script setup lang="ts">
defineComponent({
  name: 'ShareButton',
});

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
});

const {
  public: { apiUrl },
} = useRuntimeConfig();
const route = useRoute();
const url = computed(() => {
  return `${apiUrl}${route.path}`;
});

const { success } = useAlerts();

function copyLink() {
  copyToClipboard(url.value);
  success('Linked Copied');
}

async function share() {
  // using the native Web Share API
  const shareData = {
    title: props.title,
    text: props.text,
    url: url.value,
  };

  if ('share' in navigator) {
    await navigator.share(shareData);
    return;
  }

  copyLink();
}
</script>

<i18n>
{
  "en": {
    "copyLink": "Copy Link",
    "share": "Share Product",
    "linkCopied": "Link copied to clipboard"
  },
  "ar": {
    "copyLink": "انسخ الرابط",
    "share": "شارك المنتج",
    "linkCopied": "تم نسخ الرابط"
  }
}
</i18n>
